import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const AddEvaluatorInfo = createAsyncThunk(
  "EvaluatorInfo/AddEvaluatorInfo",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/EvaluatorInfo/AddEvaluatorInfo",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const DeleteEvaluatorInfo = createAsyncThunk(
  "EvaluatorInfo/DeleteEvaluatorInfo",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/EvaluatorInfo/DeleteEvaluatorInfo",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetEvaluatorInfoRowByUserId = createAsyncThunk(
  "FlowAction/GetEvaluatorInfoRowByUserId",
  async (parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Evaluator/GetEvaluatorInfoRowByUserId",
        parameter
      );

      const data = response.data.result;

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateAssigingUser = createAsyncThunk(
  "UpdateAssigingUser/UpdateAssigingUser",
  async (parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Evaluator/ChangeAssigingUser",
        parameter
      );

      const data = response.data.result;

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetEvaluatorInfoByRoundFieldSubject = createAsyncThunk(
  "EvaluatorInfo/GetEvaluatorInfoByRoundFieldSubject",
  async (parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/EvaluatorInfo/GetEvaluatorInfoByRoundFieldSubject",
        parameter
      );

      const data = response.data.result;

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateAssigingUserNew = createAsyncThunk(
  "UpdateAssigingUserNew/UpdateAssigingUserNew",
  async (parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();

      const response = await apiClient.post(
        "api/Evaluator/TransferNewRequest",
        parameter
      );
      const data = response.data;

      if (!data.success) {
        return rejectWithValue(data.message || "فشل التحويل");
      }

      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "حدث خطأ غير متوقع"
      );
    }
  }
);

const EvaluatorInfo = createSlice({
  name: "EvaluatorInfo",
  initialState: {
    //------------- AddEvaluatorInfo ---------------------
    EvaluatorInfoAdd: [],
    loadingEvaluatorInfoAdd: false,
    errorEvaluatorInfoAdd: null,
    //------------- DeleteEvaluatorInfo ---------------------
    EvaluatorInfoDelete: {},
    loadingEvaluatorInfoDelete: false,
    errorEvaluatorInfoDelete: null,
    //-----------------------------------------------------------
    EvaluatorInfoRow: [],
    loadingEvaluatorInfoRow: false,
    errorEvaluatorInfoRow: null,
    //-------------------------------------------------
    ChangeAssigingUser: [],
    loadingChangeAssigingUser: false,
    errorChangeAssigingUser: null,
    //-------------------------------------------------
    ChangeAssigingUserNew: [],
    loadingChangeAssigingUserNew: false,
    errorChangeAssigingUserNew: null,
    //-------------------------------------------------
    GetEvaluatorInfoByRoundFieldSubject: [],
    loadingGetEvaluatorInfoByRoundFieldSubject: false,
    errorGetEvaluatorInfoByRoundFieldSubject: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    //----------------------AddEvaluatorInfo---------------------
    builder
      .addCase(AddEvaluatorInfo.pending, (state, action) => {
        state.loadingEvaluatorInfoAdd = true;
        state.EvaluatorInfoAdd = action.payload;
        state.errorEvaluatorInfoAdd = null;
      })
      .addCase(AddEvaluatorInfo.fulfilled, (state, action) => {
        state.loadingEvaluatorInfoAdd = false;
        state.EvaluatorInfoAdd = action.payload;
      })
      .addCase(AddEvaluatorInfo.rejected, (state, action) => {
        state.loadingEvaluatorInfoAdd = false;
        state.EvaluatorInfoAdd = action.payload;
      });
    //----------------------DeleteEvaluatorInfo------------------
    builder
      .addCase(DeleteEvaluatorInfo.pending, (state, action) => {
        state.loadingEvaluatorInfoDelete = true;
        state.EvaluatorInfoDelete = action.payload;
        state.errorEvaluatorInfoDelete = null;
      })
      .addCase(DeleteEvaluatorInfo.fulfilled, (state, action) => {
        state.loadingEvaluatorInfoDelete = false;
        state.EvaluatorInfoDelete = action.payload;
      })
      .addCase(DeleteEvaluatorInfo.rejected, (state, action) => {
        state.loadingEvaluatorInfoDelete = false;
        state.EvaluatorInfoDelete = action.payload;
      })
      .addCase(GetEvaluatorInfoRowByUserId.pending, (state, action) => {
        state.loadingEvaluatorInfoRow = true;
        state.EvaluatorInfoRow = action.payload;
        state.errorEvaluatorInfoRow = null;
      })
      .addCase(GetEvaluatorInfoRowByUserId.fulfilled, (state, action) => {
        state.loadingEvaluatorInfoRow = false;
        state.EvaluatorInfoRow = action.payload;
      })
      .addCase(GetEvaluatorInfoRowByUserId.rejected, (state, action) => {
        state.loadingEvaluatorInfoRow = false;
        state.EvaluatorInfoRow = action.payload;
      });
    builder

      .addCase(UpdateAssigingUser.pending, (state, action) => {
        state.loadingChangeAssigingUser = true;
        state.ChangeAssigingUser = action.payload;
        state.errorChangeAssigingUser = null;
      })
      .addCase(UpdateAssigingUser.fulfilled, (state, action) => {
        state.loadingChangeAssigingUser = false;
        state.ChangeAssigingUser = action.payload;
      })
      .addCase(UpdateAssigingUser.rejected, (state, action) => {
        state.loadingChangeAssigingUser = false;
        state.errorChangeAssigingUser = action.payload;
      });
    builder

      .addCase(UpdateAssigingUserNew.pending, (state, action) => {
        state.loadingChangeAssigingUserNew = true;
        state.ChangeAssigingUserNew = action.payload;
        state.errorChangeAssigingUserNew = null;
      })
      .addCase(UpdateAssigingUserNew.fulfilled, (state, action) => {
        state.loadingChangeAssigingUserNew = false;
        state.ChangeAssigingUserNew = action.payload;
      })
      .addCase(UpdateAssigingUserNew.rejected, (state, action) => {
        state.loadingChangeAssigingUserNew = false;
        state.errorChangeAssigingUserNew = action.payload;
      });

    builder

      .addCase(GetEvaluatorInfoByRoundFieldSubject.pending, (state, action) => {
        state.loadingGetEvaluatorInfoByRoundFieldSubject = true;
        state.GetEvaluatorInfoByRoundFieldSubject = action.payload;
        state.errorChangeAssigingUserNew = null;
      })
      .addCase(
        GetEvaluatorInfoByRoundFieldSubject.fulfilled,
        (state, action) => {
          state.loadingGetEvaluatorInfoByRoundFieldSubject = false;
          state.GetEvaluatorInfoByRoundFieldSubject = action.payload;
        }
      )
      .addCase(
        GetEvaluatorInfoByRoundFieldSubject.rejected,
        (state, action) => {
          state.loadingGetEvaluatorInfoByRoundFieldSubject = false;
          state.errorGetEvaluatorInfoByRoundFieldSubject = action.payload;
        }
      );
  },
});

export default EvaluatorInfo.reducer;
